import React from "react";
import SummaryCard2 from "./SummaryCard2";

const summaryData = [
  {
    title: "Total AMC (Monthly)",
    value: "30,000",
    color: "blue",
  },
  {
    title: "Required (4 Months)",
    value: "1,20,000",

    color: "green",
  },
  {
    title: "Current Stock",
    value: "50,000",

    color: "orange",
  },
  {
    title: "Stockout Rate",
    value: "11%",

    color: "red",
  },
  {
    title: "Pipeline Coverage",
    value: "74%",
    color: "purple",
  },
];

// const miniData = [
//   {
//     icon: <Landmark size={32} />,
//     value: 33,
//     label: "Districts Covered",
//     color: "green",
//   },
//   {
//     icon: <Hospital size={32} />,
//     value: 1850,
//     label: "Facilities Covered",
//     color: "blue",
//   },
//   {
//     icon: <Pill size={32} />,
//     value: 8,
//     label: "Product Category",
//     color: "purple",
//   },
//   {
//     icon: <BriefcaseMedical size={32} />,
//     value: 352,
//     label: "Total SKUs",
//     color: "orange",
//   },
// ];

const ProcumentCalcLogic = () => {
  return (
    <>
      <div style={{padding: "0px 20px"}}>
        <div className="card formula-table" style={{ width: "100%" }}>
          <h2>Formula:</h2>
          <p>
            Procurement Qty = (AMC × 4 months) − Current Stock − Pipeline Stock
          </p>
        </div>
        <div className="card formula-table" style={{ marginTop: "20px" }}>
          <h2>Rules:</h2>
          <ul>
            <li>
              Only current physical stock at district drug warehouses is
              considered
            </li>
            <li>Pipeline stock (ordered but not yet received) is deducted</li>
            <li>
              If overall stock across districts exceeds 4 months, redistribution
              is recommended instead of procurement
            </li>
            <li>AMC is averaged across all district drug warehouses</li>
          </ul>
        </div>
      </div>
      <div className="summary-left">
        {summaryData.map((item, index) => (
          <SummaryCard2 key={index} {...item} />
        ))}
      </div>
    </>
  );
};

export default ProcumentCalcLogic;
